import _ from "underscore";
import $ from "jquery";

var UUID, mix, typeIsArray,
  slice = [].slice;

typeIsArray = Array.isArray || function(value) {
  return {}.toString.call(value) === '[object Array]';
};

UUID = (function() {
  var i, lut, self;
  self = {};
  lut = [];
  i = 0;
  while (i < 256) {
    lut[i] = (i < 16 ? '0' : '') + i.toString(16);
    i++;
  }
  self.generate = function(options) {
    var d0, d1, d2, d3, res;
    if (options == null) {
      options = {};
    }
    d0 = Math.random() * 0xffffffff | 0;
    d1 = Math.random() * 0xffffffff | 0;
    d2 = Math.random() * 0xffffffff | 0;
    d3 = Math.random() * 0xffffffff | 0;
    res = lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    if (options.noDashes) {
      return res.replace(/-/g, '');
    } else {
      return res;
    }
  };
  return self;
})();

mix = function() {
  return _.mixin({
    removeItem: function(array, item) {
      var i, results;
      i = array.length - 1;
      results = [];
      while (i >= 0) {
        if (array[i] === item) {
          array.splice(i, 1);
        }
        results.push(i--);
      }
      return results;
    },
    truncate: function(str, options) {
      if (options == null) {
        options = {};
      }
      str = str || '';
      options = _.defaults(options, {
        omission: '...',
        length: 10
      });
      if (str.length < options.length) {
        return str;
      }
      str = str.substring(0, options.length);
      return str + options.omission;
    },
    getURI: function(href) {
      var match;
      match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
      return match && {
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
      };
    },
    smartQuotes: function(str) {
      if (str == null) {
        str = "";
      }
      return str.toString().replace(/(^|[-\u2014\s(\["])'/g, '$1‘').replace(/'/g, '’').replace(/(^|[-\u2014\/\[(\u2018\s])"/g, '$1“').replace(/"/g, '”').replace(/--/g, '—');
    },
    dasherize: function(s) {
      return s.replace(/[A-Z]/g, function(char, index) {
        return (index !== 0 ? '-' : '') + char.toLowerCase();
      });
    },
    camelize: function(s, type) {
      var out;
      if (type == null) {
        type = 'lower';
      }
      out = s.replace(/(?:^|[-_])(\w)/g, function(_, c) {
        if (c) {
          return c.toUpperCase();
        } else {
          return '';
        }
      });
      if (type === 'lower') {
        return out.charAt(0).toLowerCase() + out.slice(1);
      } else {
        return out;
      }
    },
    toUnderscore: function(s) {
      return s.replace(/[A-Z]/g, function(char, index) {
        return (index !== 0 ? '_' : '') + char.toLowerCase();
      });
    },
    capitalize: function(s) {
      return s[0].toUpperCase() + s.substring(1).toLowerCase();
    },
    pluralize: function(num, singular, plural) {
      if (num <= 1) {
        return num + " " + singular;
      }
      return num + " " + (plural != null ? plural : singular + 's');
    },
    image_tag: function(path, options) {
      var el, height, width;
      if (options == null) {
        options = {};
      }
      el = $('<img>');
      if (options.alt) {
        el.attr('alt', options.alt);
      }
      el.attr('src', path);
      width = options.width, height = options.height;
      if (width != null) {
        el.css({
          width: width
        });
      }
      if (height != null) {
        el.css({
          height: height
        });
      }
      if (options.style != null) {
        if (typeof options.style === 'string') {
          el.attr('style', options.style);
        } else if (typeof options.style === 'object') {
          el.css(options.style);
        }
      }
      if (options.classList != null) {
        el.attr('class', options.classList);
      }
      return $('<div>').html(el).html();
    },
    callOrReturn: function(obj, context) {
      var ct;
      ct = context || obj;
      if (typeof obj === 'function') {
        return obj.call(ct);
      } else {
        return obj;
      }
    },
    wrap: function(item) {
      if (!typeIsArray(item)) {
        item = [item];
      }
      return item;
    },
    wrapAsArray: function(item) {
      if (!typeIsArray(item)) {
        item = [item];
      }
      return item;
    },
    only: function(targ, arr) {
      var out;
      if (arr == null) {
        arr = [];
      }
      out = _.wrap(targ).map((function(_this) {
        return function(obj) {
          obj = $.extend(true, {}, obj);
          return _(arr).reduce(function(memo, attr) {
            var key;
            key = attr;
            if (typeof attr === "object") {
              key = _(attr).keys()[0];
              memo[key] = _(obj[key]).only(attr[key]);
            } else if (_.has(obj, key)) {
              memo[key] = obj[key];
            }
            return memo;
          }, {});
        };
      })(this));
      if (_.isArray(targ)) {
        return out;
      } else {
        return out[0];
      }
    },
    except: function(obj, arr) {
      if (arr == null) {
        arr = [];
      }
      obj = $.extend(true, {}, obj);
      _(arr).each((function(_this) {
        return function(attr) {
          return delete obj[attr];
        };
      })(this));
      return obj;
    },
    uuid: UUID.generate,
    waitFor: function(promises, _deferred_, _fetchedData_) {
      _deferred_ || (_deferred_ = $.Deferred());
      _fetchedData_ || (_fetchedData_ = {});
      promises = _.wrap(promises);
      $.when.apply($, promises).then((function(_this) {
        return function() {
          _fetchedData_ = $.extend.apply($, [{}, _fetchedData_].concat(slice.call(_.toArray(arguments))));
          _this._shiftDone(promises);
          if (promises.length) {
            return _.waitFor(promises, _deferred_, _fetchedData_);
          } else {
            return _deferred_.resolve(_fetchedData_);
          }
        };
      })(this)).fail((function(_this) {
        return function() {
          return _deferred_.reject.apply(_this, arguments);
        };
      })(this));
      return _deferred_.promise();
    },
    _shiftDone: function(promises) {
      var promise, results;
      if (promises == null) {
        promises = [];
      }
      promises.sort((function(_this) {
        return function(p1, p2) {
          if (p1.state() === "resolved") {
            return -1;
          } else {
            return 1;
          }
        };
      })(this));
      promise = promises[0];
      results = [];
      while (promise && promise.state() === "resolved") {
        promises.shift();
        results.push(promise = promises[0]);
      }
      return results;
    },
    collectFunctionClass: function(func, context) {
      var classFunction, classNamespaces;
      if (!func) {
        return;
      }
      classNamespaces = func.split('.');
      classFunction = context;
      _(classNamespaces).each((function(_this) {
        return function(classNamespace) {
          return classFunction = classFunction != null ? classFunction[classNamespace] : void 0;
        };
      })(this));
      return classFunction;
    },
    isArray: function(value) {
      if (Array.isArray) {
        return Array.isArray(value);
      } else {
        return {}.toString.call(value) === '[object Array]';
      }
    },
    addClassIfFirst: function(className, i) {
      if (i === 0) {
        return className;
      }
    }
  });
};

module.exports = mix();


// WEBPACK FOOTER //
// ./src/utilities/underscoreMixins/index.js